import { CircleCombinationsQuestion } from '~/types/bootcamp'

import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'

import { CircleCombinationsActivityData } from './CircleCombinations.type'

/**
 * chooses question and options for the activity
 * @param questions all available multiple choice question
 * @param history previously selected question history
 * @returns multiple choice activity data
 */
export function generateCircleCombinationsActivityData(
  questions: CircleCombinationsQuestion[],
  history: number[],
): CircleCombinationsActivityData {
  const questionIndex = getRandomInt(0, questions.length - 1, history)
  const question = questions[questionIndex]

  return { question, questionIndex }
}
